<lms-dynamic-form
  #form
  [action]="'kepler.player.edit'"
  [options]="{
    submitLabel: 'kepler.saveMatch',
    disableCard: false,
    hideSubmit: false
  }"
  [questions]="questions"
  (submit)="onSubmit($event)"
>
  <ng-content select="[form-actions-before]" form-actions-before></ng-content>
</lms-dynamic-form>
